<div class="background-image" [style]="backgroundStyle">
  <img class="foreground-image" [src]="foregroundUrl" alt="" />
</div>
